<template>
    <div class="main-content" id="social-accounts">
        <PageTitle main-title="Social accounts" sub-title="Manage social accounts" av-icon="accounts">
            <template v-slot:page-title-actions>
            </template>
        </PageTitle>
        <div class="row row-eq-height">
            <div class="col-md-3">
                <ConnectedSocialCard title="Facebook">casvgrunsven</ConnectedSocialCard>
            </div>
            <div class="col-md-3">
                <ConnectedSocialCard title="LinkedIn">casvgrunsven</ConnectedSocialCard>
            </div>
            <div class="col-md-3">
                <ConnectedSocialCard title="Instagram">cas_van_grunsven</ConnectedSocialCard>
            </div>
            <div class="col-md-3">
                <ConnectedSocialCard variant="add"><Button variant="neutral" @click.native="showAddModal = true"><svgicon name="plus" /> Add account</Button></ConnectedSocialCard>
            </div>
        </div>

        <Modal v-if="showAddModal" @close="showAddModal=false" size="sm" id="delete-modal">
            <div v-if="!instaShow && !facebookShow && !twitterShow &&!linkedinShow">
                <h4 class="modal-title">Connect social account</h4>
                <Button variant="social-linkedin" width="expand" @click.native="linkedinShow = true">Connect LinkedIn account</Button>
                <Button variant="social-twitter" width="expand" @click.native="twitterShow = true">Connect Twitter account</Button>
                <Button variant="social-instagram" width="expand" @click.native="instaShow = true">Connect Instagram account</Button>
                <Button variant="social-facebook" width="expand" @click.native="facebookShow = true">Connect Facebook account</Button>
            </div>
            <div v-else-if="instaShow">
                <h4 class="modal-title">Connect Instagram account</h4>
                <p>To connect an Instagram account, you will have to use the Apostle Connect app.</p>
            </div>
            <div v-else-if="facebookShow">
                <h4 class="modal-title">Connect Facebook account</h4>
                <p>To connect an Facebook account, you will have to use the Apostle Connect app.</p>
            </div>
        </Modal>
    </div>
</template>
<script>
    import PageTitle from "../../components/Pagetitle/Pagetitle";
    import ConnectedSocialCard from "../../components/ConnectedSocialCard/ConnectedSocialCard";
    import Modal from "../../components/Modal/Modal";
    import Button from "../../components/Button/Button";

    export default {
        name: 'SocialAccounts',
        components: {
            Button,
            PageTitle,
            ConnectedSocialCard,
            Modal
        },
        props: [],
        data () {
            return {
                showAddModal: false,
                instaShow: false,
                facebookShow: false,
                linkedinShow: false,
                twitterShow: false
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./SocialAccounts.scss" scoped lang="scss"></style>

